module.exports = __webpack_public_path__ + "img/main.c5505519.png";